import { t } from '@hefe/i18n';
import { currentUserSelector, ModalsSlice } from '@hefe/store';
import { Alert, Col, Row } from 'antd';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';

export default function TutorialsDashboardComponent() {
  const dispatch = useAppDispatch();
  const user = useSelector(currentUserSelector);

  const locale = navigator.language.split('-')[0];

  const tutorials = useMemo(() => {
    if (!user?.unread?.tutorials || user?.unread?.tutorials.length === 0) {
      return [];
    }

    const openTutorial = (id: number) => {
      dispatch(ModalsSlice.modalsActions.openTutorialModal({ id }));
    };

    const returnValue: any[] = [];

    for (const tutorial of user.unread.tutorials.filter((t) => t.web)) {
      const title = (tutorial as any)[`name_${locale}`] || tutorial.name_de;
      const description =
        ((tutorial as any)[`description_${locale}`] ||
          tutorial.description_de) ??
        t('tutorials.alert.empty_description');

      returnValue.push(
        <Col span={8} key={tutorial.id}>
          <Alert
            message={title}
            description={description}
            type="info"
            onClick={() => openTutorial(tutorial.id)}
            style={{ cursor: 'pointer' }}
          />
        </Col>
      );
    }

    return returnValue;
  }, [user?.unread.tutorials, dispatch, locale]);

  return <Row gutter={16}>{tutorials}</Row>;
}
